import { useState, useEffect } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import './HelpPage.css'

const SECTIONS = [
  { key: 'why-causeway', label: 'Why Causeway' },
  { key: 'avc-cycle', label: 'The AVC Cycle' },
  { key: 'workflow-story', label: 'A Cycle in Practice' },
  { key: 'getting-started', label: 'Getting Started' },
  { key: 'strategy-modes', label: 'Strategy Modes' },
  { key: 'strategy-workspace', label: 'Strategy Workspace' },
  { key: 'document', label: 'Document Viewer' },
  { key: 'execution', label: 'Execution Tracking' },
  { key: 'review', label: 'Cross-Cycle Review' },
  { key: 'oracle-insights', label: 'Causal Insights' },
  { key: 'business-graph', label: 'Business Graph' },
  { key: 'canvas', label: 'Strategy Canvas' },
  { key: 'vigil', label: 'Vigil Dashboard' },
  { key: 'dossier', label: 'Company Dossier' },
  { key: 'agency', label: 'Agency Console' },
  { key: 'settings', label: 'Settings' },
  { key: 'settings-model', label: 'Settings: AI Model' },
  { key: 'data-manager', label: 'Data Manager' },
  { key: 'portfolio', label: 'Portfolio Dashboard' },
]

export default function HelpPage() {
  const [activeSection, setActiveSection] = useState('why-causeway')
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(false)

  // Sync with URL hash on mount
  useEffect(() => {
    const hash = window.location.hash.replace('#', '')
    if (hash && SECTIONS.some(s => s.key === hash)) {
      setActiveSection(hash)
    }
  }, [])

  // Fetch content when section changes
  useEffect(() => {
    setLoading(true)
    fetch(`/docs/user-guide/${activeSection}.md`)
      .then(res => res.ok ? res.text() : '# Not Found\n\nThis help section is not available yet.')
      .then(text => {
        setContent(text)
        setLoading(false)
      })
      .catch(() => {
        setContent('# Error\n\nFailed to load help content.')
        setLoading(false)
      })
  }, [activeSection])

  const handleSectionClick = (key: string) => {
    setActiveSection(key)
    window.history.replaceState(null, '', `/help#${key}`)
  }

  return (
    <div className="help-page">
      <div className="help-page-sidebar">
        <a href="/" className="help-back-link">&larr; Back to Causeway</a>
        <h2 className="help-sidebar-title">User Guide</h2>
        <nav className="help-nav">
          {SECTIONS.map(({ key, label }) => (
            <button
              key={key}
              className={`help-nav-item ${activeSection === key ? 'active' : ''}`}
              onClick={() => handleSectionClick(key)}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>
      <div className="help-page-content">
        {loading ? (
          <p className="help-page-loading">Loading...</p>
        ) : (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        )}
      </div>
    </div>
  )
}
